import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-org-admin',
  standalone: true,
  imports: [CommonModule, RouterOutlet],
  template: `
    <div class="org-layout">
      <div class="org-content">
        <router-outlet></router-outlet>
      </div>
    </div>
  `,
  styles: [`
    .org-layout {
      display: flex;
      height: 100%;
      min-height: 0;
      /* Inherit the light background from the parent app wrapper */
    }
    .org-content {
      flex: 1;
      min-width: 0;
      overflow-y: auto;
      padding: 32px;
      /* Remove forced light text color */
    }
  `],
})
export class OrgAdminComponent {}
